/*
 * @Author:
 * @Description:设置
 * @Date: 2024-11-27 10:33:04
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/router/config/settiings.js
 */
export default [
  {
    path: '/checkout/paymentSetting', //  收单-auth交易自动capture/void的设定和应用,收单商户/穿越商户才有权限看到
    name: 'Auth Capture',
    component: () => import('@/views/settings/authCapture/index.vue'),
    meta: {
      resourceCode: 'checkout:paymentSetting', // TODO:修改权限码
    },
  },
];
